export default __webpack_public_path__ + "static/media/amdlogo.7a8ab22c.png";